import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.timers.js";
//   import { ref, onMounted } from "vue";microsoft

import AccordionTabs from "@/components/pageElements/AccordionTabs.vue";
// import ToggleComponent from '@/components/form/ToggleComponent.vue';
import settingsItem from "@/components/settings/settingsItem.vue";
import MainMenuNavigationItem from "@/components/mainMenuPages/mainMenuNavigationItem.vue";
import WalkthroughPointer from "@/components/WalkthroughPointer.vue";
import ToggleComponent from "@/components/form/ToggleComponent.vue";
export default {
  name: "VoiceSelector",
  components: {
    // ToggleComponent,
    AccordionTabs: AccordionTabs,
    settingsItem: settingsItem,
    WalkthroughPointer: WalkthroughPointer,
    MainMenuNavigationItem: MainMenuNavigationItem,
    ToggleComponent: ToggleComponent
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.getLoveLevel();
          case 2:
            _this.getCurrentAvatarDetails();
            _this.pauseWord = _this.$store.state.pauseBrilliance;
            _this.continueWord = _this.$store.state.continueBrilliance;
            _this.fps = _this.$store.state.fps;
            _this.framesToRemove = _this.$store.state.speakingFramesToRemove;
            _this.delayInSpeaking = _this.$store.state.delayBeforeSpeakingInMS;
            console.log("<<<<<<<<< voiceSelector mounted >>>>>>>>>");
            // console.log('voice selector start');
            // if (window.speechSynthesis.onvoiceschanged !== undefined) {
            //   window.speechSynthesis.onvoiceschanged = this.populateVoices();
            // }

            // this.voices = this.voices.filter(voice => voice.lang.includes(this.selectedLanguage));
            if (_this.$store.state.selectedAvatarVoice) {
              _this.selectedVoice = _this.$store.state.selectedAvatarVoice;
            }
            if (_this.$store.state.selectedAvatarLanguage) {
              _this.selectedLanguage = _this.$store.state.selectedAvatarLanguage;
            }
            if (_this.$store.state.selectedAvatarVoiceRate) {
              _this.voiceRate = _this.$store.state.selectedAvatarVoiceRate;
            }
            _this.updateVoices();
            setTimeout(function () {
              _this.makeItSpeakNow();
            }, 1000);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  props: {
    avatarSettings: {
      type: Array
    }
  },
  methods: {
    updateAI: function updateAI() {
      var model = 'default';
      if (this.$store.state.aiModel != 'gemini') {
        model = 'gemini';
      }
      this.$store.commit("updateAIModel", model);
    },
    getLoveLevel: function getLoveLevel() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var axios, data, config, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              axios = require("axios");
              data = {
                token: localStorage.getItem("security")
              };
              config = {
                method: "post",
                url: "".concat(_this2.$store.state.systemRoute, "/loveMeter"),
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                data: data
              };
              _context2.next = 5;
              return axios(config);
            case 5:
              response = _context2.sent;
              console.log('[voiceSelector]', response);
              _this2.likeability = response.data.like_meter;
              console.log('likeability', response.data.like_meter);
              _this2.scaleLikeability();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    scaleLikeability: function scaleLikeability() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this3.likeabilityStart < _this3.likeability)) {
                _context3.next = 6;
                break;
              }
              console.log('moving needle');
              _this3.likeabilityStart = _this3.likeabilityStart + 1;
              _context3.next = 5;
              return new Promise(function (r) {
                return setTimeout(r, 50);
              });
            case 5:
              _this3.scaleLikeability();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getNeedleStyle: function getNeedleStyle() {
      var rotation = -90 + (this.likeabilityStart - 0) / (100 - 0) * 180;
      return "transform:rotate(".concat(rotation, "deg)");
    },
    getGaugeStyle: function getGaugeStyle() {
      return "--gauge-width: 200px; --min: 0; --max: 100; --actual-value: ".concat(this.likeabilityStart);
    },
    getCurrentAvatarDetails: function getCurrentAvatarDetails() {
      for (var p = 0; p < this.$store.state.avatarList.length; p++) {
        if (this.$store.state.avatarList[p].name == this.$store.state.avatar) {
          this.currentAvatar = this.$store.state.avatarList[p];
        }
      }
    },
    openAvatarSelector: function openAvatarSelector() {
      // this.$store.commit('updateShowAvatarSelector', true)
      this.$store.commit('updatePreventIntroExperience', true);
      // this.$store.commit('startIntroPage', 'Interests');
      this.$store.commit('startIntroPage', 'QuickMessage');
      this.$store.commit('updateShowAvatarSettings', false);
      this.$store.commit('mainMenuClose');
    },
    savePause: function savePause() {
      this.$store.commit("updatePauseBrilliance", this.pauseWord);
      this.$store.commit("showSnackbarInfo", "Pause Word Updated");
    },
    saveContinue: function saveContinue() {
      this.$store.commit("updateContinueBrilliance", this.continueWord);
      this.$store.commit("showSnackbarInfo", "Continue Word Updated");
    },
    setDelayInSpeaking: function setDelayInSpeaking() {
      this.$store.commit("updateDelayBeforeSpeakingInMS", this.delayInSpeaking);
      this.$store.dispatch("showSnackbar", {
        text: "Delay in Speaking Updated",
        color: "#00C853",
        textColor: "black"
      });
    },
    setFramesToRemove: function setFramesToRemove() {
      this.$store.commit("updateSpeakingFramesToRemove", this.framesToRemove);
      this.$store.dispatch("showSnackbar", {
        text: "Frames to Remove Updated",
        color: "#00C853",
        textColor: "black"
      });
    },
    setFPS: function setFPS() {
      this.$store.commit("updateFPS", this.fps);
      this.$store.dispatch("showSnackbar", {
        text: "FPS Updated",
        color: "#00C853",
        textColor: "black"
      });
    },
    makeItSpeakNow: function makeItSpeakNow() {
      this.speakNow = true;
      this.$store.commit("updateUseAudio", true);
    },
    updateVoices: function updateVoices() {
      var _this4 = this;
      console.log("selected updatedVoices");
      var synth = window.speechSynthesis;
      var voices = synth.getVoices();

      // remove all voices that contain URI with eloquence in them
      // this is a hack to remove the eloquence voices from the list
      this.voices = voices.filter(function (voice) {
        return !voice.voiceURI.includes("eloquence") && !voice.voiceURI.includes("Bubbles");
      });
      this.voices = this.voices.filter(function (voice) {
        return voice.lang.includes(_this4.selectedLanguage);
      });
      // this.voices = voices;
    }
  },
  watch: {
    // 'likeabilityStart': function(){
    //   this.scaleLikeability();
    // },
    selectedVoice: function selectedVoice(newVal, oldVal) {
      console.log("selectedVoice changed");
      if (newVal != oldVal) {
        console.log("selected voice changed", newVal);
        this.$store.commit("updateSelectedAvatarVoice", newVal);
        this.$store.commit("updateSelectedAvatarLanguage", this.selectedLanguage);
        if (this.speakNow) {
          this.$store.commit("updateUseAudio", true);
          this.$store.commit("updateSpeakToProcess", "This is my voice.");
        }
      }
    },
    selectedLanguage: function selectedLanguage() {
      console.log("selected language");
      this.updateVoices();
    },
    voiceRate: function voiceRate(newVal) {
      console.log("voice rate changed", newVal);
      this.$store.commit("updateSelectedAvatarVoiceRate", newVal);
    }
  },
  data: function data() {
    return {
      likeability: 0,
      currentAvatar: null,
      likeabilityStart: 0,
      pauseWord: null,
      continueWord: null,
      VoiceSettings: [{
        label: "Use Activation Word",
        storeItem: "useActivationWord",
        icon: "wave-pulse",
        description: "If enabled, you will have to use the name of the AIVitar before it will talk back."
      }, {
        label: "Improved Speech To Text",
        proFeature: true,
        storeItem: "onDeviceAudioRecording",
        flipLogic: true,
        // this flips the logic of the store item so that true means false and false means true, useful for when store state is backwards
        icon: "comment-text",
        description: 'Improved speech to text allows cloud-based speech to text to be used instead of the device\'s native speech to text.  This is useful if you have a lot of background noise but using this does reduce response times.'
      }, {
        label: "Improved Text To Speech",
        proFeature: true,
        flipLogic: true,
        storeItem: "onDeviceTextToSpeech",
        icon: "comment-text",
        description: "If enabled this will use the phones native device text to speech"
      }, {
        label: "Dial-In",
        storeItem: "showPhoneOnStartup",
        icon: "phone",
        description: 'If enabled, this requires you to "call" your AIVitar before talking each time'
      }, {
        label: "Text Only",
        storeItem: "textOnlyMode",
        icon: "keyboard",
        description: "When enabled, will allow typing and text responses only"
      }, {
        label: "Enable Bluetooth Controller",
        storeItem: "bluetoothControllerConnected",
        icon: "keyboard",
        description: "Allows you to control the AIVitar remotely using the bluetooth ring device. Without the ring, if you enable this you might not be able to use the screen unless you refresh the app."
      }, {
        label: "Context",
        storeItem: "useContext",
        icon: "comment-dots",
        description: "When enabled, allows the agent to know what you have previously said to use in responding to additional questions"
      },
      // {
      // 	label: 'Continuous Mode',
      // 	storeItem: 'continuousListenMode',
      // 	icon: 'angle-double-right',
      // 	description: 'When enabled, agent will continue to listen and only respond when it hears the activation word'
      // },
      {
        label: "Allow Charts",
        storeItem: "enableChartResponses",
        proFeature: true,
        icon: "line-chart",
        description: "When enabled, agent will try to determine if best response should be a chart and will show charted data on demand"
      }, {
        label: "Allow Code",
        storeItem: "enableCodeResponses",
        icon: "code",
        description: "When enabled, agent will try to determine if best response should to show you source code snippets"
      },
      // {
      // 	label: 'Show Logs',
      // 	storeItem: 'showLogs',
      // 	icon: 'code',
      // 	description: 'When enabled, shows you detailed logs for development'
      // },
      {
        label: "Exceptional Mode",
        proFeature: true,
        storeItem: "exceptionalMode",
        icon: "magic",
        description: "When enabled, it improves interactions substantially for code, charts and other advanced features."
      }],
      fps: 0,
      framesToRemove: 0,
      delayInSpeaking: 0,
      speakNow: false,
      voices: [],
      selectedVoice: null,
      voiceRate: 1,
      selectedLanguage: "en-",
      //creates list of languages to choose from
      languages: [{
        name: "English",
        value: "en-"
      }, {
        name: "Français",
        value: "fr-"
      }, {
        name: "Español",
        value: "es-"
      }, {
        name: "Deutsch",
        value: "de-right"
      }, {
        name: "Italiano",
        value: "it-"
      }, {
        name: "Português",
        value: "pt-"
      }, {
        name: "Polskie",
        value: "pl-"
      }, {
        name: "Nederlands",
        value: "nl-"
      }, {
        name: "Русский",
        value: "ru-"
      }, {
        name: "日本語",
        value: "ja-"
      }, {
        name: "中文",
        value: "zh-"
      }, {
        name: "한국어",
        value: "ko-"
      }, {
        name: "العربية",
        value: "ar-"
      }, {
        name: "हिन्दी",
        value: "hi-"
      }, {
        name: "Svenska",
        value: "sv-"
      }, {
        name: "Dansk",
        value: "da-"
      }, {
        name: "Suomi",
        value: "fi-"
      }, {
        name: "Norsk",
        value: "nb-"
      }, {
        name: "Čeština",
        value: "cs-"
      }, {
        name: "Slovenčina",
        value: "sk-"
      }, {
        name: "Türkçe",
        value: "tr-"
      }, {
        name: "Magyar",
        value: "hu-"
      }, {
        name: "Română",
        value: "ro-"
      }, {
        name: "Català",
        value: "ca-"
      }, {
        name: "Bahasa Indonesia",
        value: "id-"
      }, {
        name: "Tiếng Việt",
        value: "vi-"
      }, {
        name: "ภาษาไทย",
        value: "th-"
      }, {
        name: "Ελληνικά",
        value: "el-"
      }]
    };
  }
};